import {
  CategorizedFilingStateTypes,
  TaskDeadlineState,
} from "types/Models/task";

export const DEFAULT_TASK_STATES: Record<
  CategorizedFilingStateTypes,
  TaskDeadlineState
> = {
  PAYMENT: {
    uuid: "02460910-2dad-4810-b8c1-59dd4ab5c5d1",
    name: "Pricing",
    is_final: false,
    type: 2,
    type_str: "PAYMENT",
    next_state: "ef13d20f-6c51-477d-b35e-a54bb6ca2b6f",
    state_json: {
      abc: "def",
    },
    is_state_reversible: false,
    is_customer_state: true,
    is_cpa_state: true,
    state_completed: null,
    index: 1,
    order: -1,
    is_task_state_completed: false,
  },
  FORM_FILING: {
    uuid: "ef13d20f-6c51-477d-b35e-a54bb6ca2b6f",
    name: "Add Details",
    is_final: false,
    type: 0,
    type_str: "FORM_FILING",
    next_state: "e30f78a6-c0f9-4841-a6a4-04bb8b28ddb4",
    state_json: {
      form_template: "5d332222-f2c5-4527-9b40-9da5656231ba",
    },
    is_state_reversible: true,
    is_customer_state: true,
    is_cpa_state: true,
    state_completed: null,
    index: 2,
    order: 0,
    is_task_state_completed: false,
  },
  FILING_IN_PROGRESS: {
    uuid: "f2ae4eb1-d610-4b66-a628-ec611caee187",
    name: "Filing in progress",
    is_final: false,
    type: 4,
    type_str: "FILING_IN_PROGRESS",
    next_state: "38301266-1356-4be0-a139-f19059626178",
    state_json: {
      data: [],
    },
    is_state_reversible: true,
    is_customer_state: false,
    is_cpa_state: true,
    state_completed: null,
    index: 3,
    order: 3,
    is_task_state_completed: false,
  },
  SUBMITTED: {
    uuid: "38301266-1356-4be0-a139-f19059626178",
    name: "Successfully Filed",
    is_final: true,
    type: 5,
    type_str: "SUBMITTED",
    next_state: null,
    state_json: {
      dummy: "",
    },
    is_state_reversible: true,
    is_customer_state: false,
    is_cpa_state: true,
    state_completed: null,
    index: 4,
    order: 4,
    is_task_state_completed: false,
  },
  TASK_AMENDMENT: {
    uuid: "38301266-1356-4be0-a139-f19059626178",
    name: "Task Amendment",
    is_final: true,
    type: 5,
    type_str: "TASK_AMENDMENT",
    next_state: null,
    state_json: {
      dummy: "",
    },
    is_state_reversible: true,
    is_customer_state: false,
    is_cpa_state: true,
    state_completed: null,
    index: 4,
    order: 4,
    is_task_state_completed: false,
  },
  TASK_AMENDMENT_COMPLETED: {
    uuid: "38301266-1356-4be0-a139-f19059626178",
    name: "Task Amendment Completed",
    is_final: true,
    type: 5,
    type_str: "TASK_AMENDMENT_COMPLETED",
    next_state: null,
    state_json: {
      dummy: "",
    },
    is_state_reversible: true,
    is_customer_state: false,
    is_cpa_state: true,
    state_completed: null,
    index: 4,
    order: 4,
    is_task_state_completed: false,
  },
};
